import React, { useState } from "react";
import { VERTICALS, HTTP_CODES } from "../../constants/app-constant";
import { EditIcon, DeleteIcon } from "../Icons/icons.component";
import { ConfirmModal } from "../Shared/Modal";
import { httpDelete } from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { useSelector } from "react-redux";
const { DELETED } = HTTP_CODES;

export default function TopicsList({
  setEditData,
  handleEntityChange,
  entityList,
  isOnline,
  isPrint,
  isSocial,
  isWidgetPage,
  selectedTopicList,
  setSelectedTopicList,
  fetchSocialTopics,
}) {
  const [hideMoreForPrint, setHideMoreForPrint] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [selectAll, setSelectAll] = useState(false);
  const [deletionInProgress, setDeletionInProgress] = useState(false);
  const timeStamp = Date.now();
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  function deleteTopics(entity) {
    if (!entity.id) {
      return;
    }
    setDeleteId(entity.id);
    setShowDeleteConfirm(true);
  }

  function onCancelDeleteTopic() {
    setDeleteId("");
    setShowDeleteConfirm(false);
  }

  function deleteTopic() {
    if (!deleteId) {
      return;
    }
    setDeletionInProgress(true);
    httpDelete(
      `${unifiedEnvConfig.DELETE_TOPIC}/${deleteId}?client_id=${
        selectedClient && selectedClient.id
      }`
    )
      .then(({ status, message }) => {
        if (status === DELETED) {
          fetchSocialTopics(true, entityList.length);
        } else {
          alert(message || "Error while deleting Topic");
        }
      })
      .catch(() => {
        alert("Error while deleting Topic");
      })
      .finally(() => {
        setDeleteId("");
        setShowDeleteConfirm(false);
        setDeletionInProgress(false);
      });
  }

  const currentData = () => {
    if (entityList) {
      if (isSocial) {
        return entityList;
      }
      if (!hideMoreForPrint) {
        return [...entityList].splice(0, 10);
      }
      return entityList;
    }
    return [];
  };

  const handleTopicNameClick = (e, entity) => {
    const { V_SOCIAL, V_PRINT, V_ONLINE } = VERTICALS;
    if (isWidgetPage) {
      return null;
    }
    let tab = isPrint ? V_PRINT : isOnline ? V_ONLINE : V_SOCIAL;
    handleEntityChange(e, entity, tab);
  };

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  const handleTopicSelection = (e) => {
    const value = e.target.value;
    const tempArray = [...selectedTopicList];
    const elmIndex = tempArray.indexOf(value);
    if (elmIndex === -1) {
      tempArray.push(value);
      setSelectedTopicList(tempArray);
    } else {
      tempArray.splice(elmIndex, 1);
      setSelectedTopicList(tempArray);
    }
  };

  const isChecked = (v) => {
    try {
      const strValue = v.toString();
      return selectedTopicList.indexOf(strValue) !== -1;
    } catch (e) {
      return false;
    }
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    let tempArray = [];
    if (!selectAll) {
      tempArray = [...currentData().map((item) => item.id)];
    } else {
      tempArray = [];
    }
    setSelectedTopicList(tempArray);
  };

  return (
    <>
      {isWidgetPage && currentData().length > 0 ? (
        <tr key={timeStamp}>
          <td>
            <strong>Select All</strong>
          </td>
          <td>
            <label className="inputWrap">
              <input
                onClick={(e) => handleSelectAll(e)}
                checked={selectAll}
                type="checkbox"
              />
              <span className="checkmark"></span>
            </label>
          </td>
        </tr>
      ) : null}
      {Array.isArray(currentData()) &&
        currentData().map((entity) => {
          if (!entity) {
            return null;
          }
          const { entity_display_name, id, name } = entity || {};
          return (
            <>
              <tr key={id}>
                <td onClick={(e) => handleTopicNameClick(e, entity)}>
                  <strong>{name || entity_display_name}</strong>
                </td>
                {isSocial && !isWidgetPage && (
                  <>
                    <td
                      onClick={(e) => handleTopicNameClick(e, entity)}
                      className="topicDate"
                    >
                      {formatDate(entity.created_at)}
                    </td>
                    <td>
                      <button
                        className="btn editBtn"
                        onClick={(e) => setEditData(entity)}
                      >
                        <EditIcon />
                      </button>
                      <button
                        className="btn deleteBtn"
                        onClick={(e) => deleteTopics(entity)}
                      >
                        {" "}
                        <DeleteIcon />
                      </button>
                    </td>
                  </>
                )}
                {isWidgetPage && (
                  <td>
                    <label className="inputWrap">
                      <input
                        value={id}
                        onClick={handleTopicSelection}
                        checked={isChecked(id)}
                        type="checkbox"
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                )}
              </tr>
            </>
          );
        })}
      <ConfirmModal
        show={showDeleteConfirm}
        onCancel={onCancelDeleteTopic}
        modalTitle="Delete Topic"
        confirmButtonText={deletionInProgress ? "Deleting..." : "Delete"}
        confirmText="Are you sure you want to delete this Topic?"
        onConfirm={deleteTopic}
        disableSubmit={deletionInProgress}
      />
    </>
  );
}
